import { useEffect, useLayoutEffect, useRef, useState } from 'react';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export function useReveal(threshold = 0.15) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  // Trigger immediately if element is already in viewport at mount.
  useIsomorphicLayoutEffect(() => {
    const el = ref.current; if (!el) return;
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) {
      // schedule on next frame so initial transform paints first
      requestAnimationFrame(() => requestAnimationFrame(() => setShown(true)));
    }
  }, []);

  useEffect(() => {
    const el = ref.current; if (!el) return;
    const fb = setTimeout(() => setShown(true), 800);
    if (typeof IntersectionObserver === 'undefined') { setShown(true); return () => clearTimeout(fb); }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { setShown(true); obs.unobserve(el); clearTimeout(fb); }
      });
    }, { threshold, rootMargin: '0px 0px -5% 0px' });
    obs.observe(el);
    return () => { obs.disconnect(); clearTimeout(fb); };
  }, [threshold]);

  return [ref, shown];
}
